
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {BModal} from "bootstrap-vue";
    import { Prop } from 'vue-property-decorator';
    import {RawLocation} from "vue-router";
    import CardQuicklink from "@/features/dashboard/components/CardQuicklink.vue";

    @Component({
        components: {
            CardQuicklink
        }
    })
    export default class AddQualificationModal extends Vue{
        @Prop({default:"educational-add"})
        educationalRouteName!: string;

        @Prop({default: "training-add"})
        trainingRouteName!: string;
        
        seafarerId = "";
        
        $refs!:{
            modal: BModal;
        }
        
        getTrainingUrl():RawLocation{
            return {name: this.trainingRouteName, params:{seafarerId: this.seafarerId}};
        }

        getEducationalUrl():RawLocation{
            return {name: this.educationalRouteName, params:{seafarerId: this.seafarerId}};
        }
        
        public open(seafarerId: string){
            this.seafarerId = seafarerId;
            this.$refs.modal.show();
        }
    }
